import React from "react";
import { AuditLog } from "@common/types/auditLog";
import { Entity } from "@common/types/entity";
import { EntityAvatarGroup } from "@components/avatar/EntityAvatarGroup";
import styles from "./ChatTaskAuditLog.module.scss";

interface Props {
    log: AuditLog;
}

export const ChatTaskEntities: React.FC<Props> = ({ log }) => {
    const newEntities =
        (log.diff.find((d) => d.field === "entities")?.after
            ?.value as Entity[]) ?? [];

    const oldEntities =
        (log.diff.find((d) => d.field === "entities")?.before
            ?.value as Entity[]) ?? [];

    if (!newEntities.length) {
        return (
            <>
                <span className={styles.chatTaskMessage}>removed entity</span>
                <EntityAvatarGroup
                    entities={oldEntities}
                    max={3}
                    size="sm"
                    className={styles.chatTaskEntitiesList}
                />
            </>
        );
    }

    return (
        <>
            <span className={styles.chatTaskMessage}>
                changed the entities to
            </span>
            <EntityAvatarGroup
                entities={newEntities}
                max={3}
                size="sm"
                className={styles.chatTaskEntitiesList}
            />
        </>
    );
};
